import { mapEnumToOptions } from '@abp/ng.core';

export enum PersonKind {
  Individual = 1,
  Company = 2,
}

export const personKindOptions = mapEnumToOptions(PersonKind);
